import { faCircleX } from '@fortawesome/pro-light-svg-icons';
import {
  AlertModal,
  CustomButton,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { sendCustomEvent } from '@foxtrotplatform/platform-micro-site-core';
import { FunctionComponent, useCallback } from 'react';

import { SignUpStep } from '../../../common/provider/SignUpContext';
import { useSignUp } from '../../../common/hooks/useSignUp';

interface ClearSelectedPlanModalProps {
  onGoBack: () => void;
  onContinue: () => void;
  isModalOpen: boolean;
}

export const ClearSelectedPlanModal: FunctionComponent<
  ClearSelectedPlanModalProps
> = ({ onGoBack, isModalOpen, onContinue }) => {
  const { currentStep } = useSignUp();
  const handleOnGoBackClick = useCallback(() => {
    if (onGoBack) {
      onGoBack();
      sendCustomEvent({
        category: SignUpStep[currentStep],
        action: 'Go back to selected product family',
        label: 'User clicked "Go Back" to originally selected product family',
        nonInteraction: false,
        href: window.location.href,
      });
    }
  }, [onGoBack, currentStep]);

  const handleOnContinueClick = useCallback(() => {
    if (onContinue) {
      onContinue();
      sendCustomEvent({
        category: SignUpStep[currentStep],
        action: 'Clear old selected plan and continue to new product family',
        label:
          'User clicked "Continue to Clear" to selected plan from new product family',
        nonInteraction: false,
        href: window.location.href,
      });
    }
  }, [onContinue, currentStep]);

  return (
    <AlertModal
      icon={faCircleX}
      title="Previous selection will be cleared"
      onClose={handleOnGoBackClick}
      isModalOpen={isModalOpen}
      isError={true}
      footer={
        <div className="flex flex-row gap-x-8">
          <CustomButton
            actionType="primary"
            onClick={handleOnGoBackClick}
            className="text-sm"
          >
            Go Back
          </CustomButton>
          <CustomButton
            actionType="secondary"
            onClick={handleOnContinueClick}
            className="text-sm"
          >
            Continue to Clear
          </CustomButton>
        </div>
      }
    >
      <span className="text-sm">
        Please select plans from one tab at a time, additional plans can be
        subscribed to later in the OS1 Marketplace. By clicking continue, you
        will clear your selection.
      </span>
    </AlertModal>
  );
};
